import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './DepartmentServices.css';

const DepartmentServices = ({ title, subtitle, services }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }
    }
  };

  return (
    <section className="department-services" ref={ref}>
      <div className="services-bg-pattern"></div>
      <div className="container">
        <motion.div
          className="department-services-header"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="services-tag">{title}</span>
          <h2>{subtitle}</h2>
        </motion.div>

        <motion.div
          className="department-services-grid"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card-3d"
              variants={itemVariants}
            >
              <div className="service-card-inner">
                {/* Face avant */}
                <div className="service-front">
                  <div className="service-icon-wrapper" style={{ '--service-color': service.color }}>
                    <div className="service-icon-glow"></div>
                    <FontAwesomeIcon icon={service.icon} className="service-icon" />
                  </div>
                  <h3>{service.title}</h3>
                  <p>{service.frontDesc}</p>
                  <span className="service-hint">Survolez pour explorer</span>
                  <div className="service-front-line" style={{ background: service.color }}></div>
                </div>

                {/* Face arrière */}
                <div
                  className="service-back"
                  style={{ backgroundImage: `url(${service.image})` }}
                >
                  <div className="service-back-overlay" style={{ backgroundColor: service.overlayColor || 'rgba(0,0,0,0.66)' }}>
                    <div className="service-back-icon">
                      <FontAwesomeIcon icon={service.icon} />
                    </div>
                    <h3>{service.title}</h3>
                    <p>{service.backDesc}</p>
                    <a href={service.devisLink || '#contact'} className="btn-service-devis">
                      {service.devisLabel || 'Obtenir un devis'}
                      <span className="btn-arrow"></span>
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default DepartmentServices;